export const DefaultFolderIcon = ({ size = 50 }: { size?: number }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M10 4H4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V8C22 6.89543 21.1046 6 20 6H12L10 4Z"
            stroke="#687078"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="#E9EBED"
        />
    </svg>
);
